import {getApiUrlFromEventType} from 'api/urls'
import {apiFetch} from 'lib/fetch'
import type {EventType} from 'types/event'
import type {DateString, DateTimeString} from 'types/generic'

export interface PlannerEventCreate {
  start_at: DateTimeString
  end_at: DateTimeString
  type: EventType
  text: string | null
  stakeholder_act: {
    department: {id: number}
  }
}

export interface PlannerEventUpdate extends PlannerEventCreate {
  id: number
}

export type PlannerEventDelete = Pick<PlannerEventUpdate, 'id' | 'type'>

export interface PlannerEventCreateResponse extends PlannerEventCreate {
  id: number
  start_on: DateString
  end_on: DateString
  url: string
}
export type PlannerEventUpdateResponse = PlannerEventCreateResponse

export const plannerEvents = {
  create: (data: PlannerEventCreate) => {
    return apiFetch.post<PlannerEventCreateResponse>(
      getApiUrlFromEventType(data.type),
      data
    )
  },
  update: ({id, ...data}: PlannerEventUpdate) => {
    return apiFetch.put<PlannerEventUpdateResponse>(
      getApiUrlFromEventType(data.type, id),
      data
    )
  },
  delete: ({id, ...data}: PlannerEventDelete) => {
    return apiFetch.delete<void>(getApiUrlFromEventType(data.type, id), data)
  },
}
